import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"
import { Link, useHistory, useLocation } from "react-router-dom"

import { checkId } from "crud/auth.crud"
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// action
import { registerUser, apiError, registerUserFailed } from "store/actions"

import Util from "pages/Dashboard/Common/Util";

// Redux
import { connect } from "react-redux"

// import images
import weaver from "assets/images/weaver.png";
import logo_long from "assets/images/logo-long.png"

import RegisterBar from "../RegisterBar";

// 주소 찾기
import DaumPostcode from 'react-daum-postcode';

const RegisterStep1 = props => {

  const [prevState, setPrevState] = useState({})
  const history = useHistory()
  const location = useLocation()
  const [enrollZip, setEnrollZip] = useState({address:'',});
  const [enrollStreet, setEnrollStreet] = useState({address2:'',});
  const [companyAddress2, setCompanyAddress2] = useState('')
  const [popup, setPopup] = useState(false);
  const [memberId, setMemberId] = useState('');
  const [memberIdProto, setMemberIdProto] = useState('');
  const [companyNumber, setCompanyNumber] = useState('');
  const [memberTelephone, setMemberTelephone] = useState('');
  const [memberFax, setMemberFax] = useState('')
  const [memberCellphone, setMemberCellphone] = useState('')
  const [memberPassword, setMemberPassword] = useState('')
  const [memberPasswordConfirm, setMemberPasswordConfirm] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [memberName, setMemberName] = useState('')
  const [memberEmail, setMemberEmail] = useState('')

  
  const handleValidSubmit = () => {
    // if(!memberId){
    //   return alert("아이디 중복확인을 해주세요.")
    // }
    // if(!memberPassword){
    //   return alert('비밀번호를 입력해주세요.')
    // }
    // let regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    // if(!regex.test(memberPassword)){
    //   return alert('8자 이상의 영문/숫자 조합으로 비밀번호를 입력해주세요.')
    // }
    // if(memberPassword !== memberPasswordConfirm){
    //   return alert("비밀번호 확인이 비밀번호와 다릅니다.")
    // }
    // if(companyName === ''){
    //   return alert('업체명을 입력해주세요.')
    // }
    // if(memberName === ''){
    //   return alert('대표자명을 입력해주세요.')
    // }
    // if(companyNumber === ''){
    //   return alert('사업자등록번호를 입력해주세요.')
    // }
    // if(enrollZip.address === ''){
    //   return alert('우편번호를 입력해주세요.')
    // }
    // if(enrollStreet.address2 === ''){
    //   return alert('주소를 입력해주세요.')
    // }
    // if(memberEmail === ''){
    //   return alert('이메일을 입력해주세요.')
    // }
    // let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    // if(!reg.test(memberEmail)){
    //   return alert('유효한 이메일을 입력해주세요.')
    // }
    
    const url = {
      pathname : `/register-step2`,
      state : {
        ...prevState,
        memberId: memberId,
        memberPassword: memberPassword,
        companyName: companyName,
        memberName: memberName,
        companyNumber: companyNumber,
        zipCode: enrollZip.address,
        companyAddress1: enrollStreet.address2,
        companyAddress2: companyAddress2,
        memberEmail: memberEmail,
        memberTelephone: memberTelephone,
        memberFax: memberFax,
        memberCellphone: memberCellphone
      }
    }
    history.push(url);
  }

  useEffect(() => {
    setPrevState(location.state)
    props.apiError("")
  }, [location]);

  const checkUserId = async ()=>{
    if(memberIdProto.length === 0){
      return alert('아이디를 입력해주세요.')
    }
    var reg = /^[A-Za-z\d]{3,15}$/
    if(!reg.test(memberIdProto)){
      return alert('3-15자의 영문/숫자 조합으로 아이디를 입력해주세요.')
    }
    const params = {
      user_id : memberIdProto,
    }
    const rs = await checkId(params)
    if(rs.data?.result === 'success'){
        setMemberId(memberIdProto)  
        alert('사용할 수 있는 아이디입니다.')    
    }else{
      alert('사용중인 아이디입니다.') 
    }
  }

  // 주소찾기 API
  const Post = (props) => {

    const complete = (data) =>{
      // data.zonecode는 우편번호, data.roadAddress는 도로명주소
      let zipAddress = data.zonecode;
      let roadAddress = data.roadAddress;

      props.setZipCode({
          ...props.zipCode,
          address:zipAddress
      })
        props.setStreetAddress({
          ...props.streetAddress,
          address2:roadAddress
      })
    }

    return (
      <div>
        <DaumPostcode
          className="postmodal"
          autoClose
          onComplete={complete} />
      </div>
    );
  };

  // const handleInput = (e) => {
  //   setEnrollZip({...enrollZip, [e.target.name]:e.target.value,})
  // }

  // const handleInput2 = (e) => {
  //   setEnrollStreet({...enrollStreet, [e.target.name]:e.target.value,})
  // }
  
  const handleComplete = () => {
    setPopup(!popup);
  }

  useEffect(()=>{
    setPopup(false)
  }, [enrollStreet])

  return (
    <React.Fragment>
      <MetaTags>
        <title>회원가입 | 웨이스트버스</title>
      </MetaTags>
      <div className="account-pages my-4 px-1">
        <Container className="membership-box">
          <Link to="">
            <img src={logo_long} className="mb-4" />
          </Link>
          <RegisterBar className="margin-bottom-48" circleNumber={5} actionNumber={3} title="정보입력" />
          <Row className="justify-content-center">
            <Col md={11}>
              <Card className="overflow-hidden">
                <CardBody className="p-4">
                  <div>

                      <div className="d-flex mb-4">
                        <div style={{flexGrow: 1}}>
                          <p className="noMargin text-black font-weight-bold font-size-16">아이디</p>
                          <input type="text" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" placeholder="3-15자의 영문/숫자 조합" 
                            onChange={(e) => {
                              setMemberIdProto(e.target.value)
                              setMemberId('')
                            }}
                          />
                        </div>
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-top-35 margin-left-6 font-size-16"
                            onClick={() => {
                              checkUserId(true)
                            }}
                          >중복확인</button>
                        </div>
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">비밀번호</p>
                        <input type="password" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" placeholder="8자 이상의 영문/숫자 조합" onChange={(e)=>{
                          setMemberPassword(e.target.value)
                        }} />
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">비밀번호 확인</p>
                        <input type="password" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" placeholder="비밀번호를 다시 입력해주세요." onChange={(e)=>{
                          setMemberPasswordConfirm(e.target.value)
                        }} />
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">업체명</p>
                        <input type="text" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" placeholder="업체명을 입력해주세요." onChange={(e)=>{
                          setCompanyName(e.target.value)
                        }} />
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">대표자명</p>
                        <input type="text" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" placeholder="실명을 입력해주세요." onChange={(e)=>{
                          setMemberName(e.target.value)
                        }} />
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">사업자등록번호</p>
                        <input type="text" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" value={companyNumber} placeholder="000-00-00000" onChange={(e)=>{
                          setCompanyNumber(Util.checkBusinessNumber(e.target.value))
                        }} />
                      </div>

                      <div className="mb-4">
                        <div style={{display: 'flex'}}>
                          <div>
                            <p className="noMargin text-black font-weight-bold font-size-16">주소</p>
                            <input type="text" value={enrollZip.address} placeholder="우편번호" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" style={{width: 150}} disabled />
                          </div>
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-top-35 margin-left-6 font-size-16" 
                          onClick={handleComplete}>주소찾기</button>
                          </div>
                        </div>
                        <div className="address_search" >
                          {popup && <Post company={enrollZip} setZipCode={setEnrollZip} setStreetAddress={setEnrollStreet}></Post>}
                        </div>
                        <input type="text" value={enrollStreet.address2} className="is-touched is-dirty av-valid form-control mt-2 font-size-16" placeholder="주소를 입력해주세요." disabled />
                        <input type="text" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" placeholder="상세주소를 입력해주세요." onChange={(e)=>{
                          setCompanyAddress2(e.target.value)
                        }} />
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">이메일</p>
                        <input type="email" placeholder="이메일을 입력해주세요." className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e)=>{
                          setMemberEmail(e.target.value)
                        }} />
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">전화번호</p>
                        <input type="text" value={memberTelephone} placeholder="전화번호를 입력해주세요." className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e)=>{
                          setMemberTelephone(Util.handlePhoneNumberChange(e.target.value))
                        }} />
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">팩스번호</p>
                        <input type="text" value={memberFax} placeholder="팩스번호를 입력해주세요." className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e)=>{
                          setMemberFax(Util.handlePhoneNumberChange(e.target.value))
                        }} />
                      </div>

                      <div className="mb-4">
                        <p className="noMargin text-black font-weight-bold font-size-16">휴대폰 번호</p>
                        <input type="text" value={memberCellphone} placeholder="휴대폰번호를 입력해주세요." className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e)=>{
                          setMemberCellphone(Util.handleMobileNumberChange(e.target.value))
                        }} />
                      </div>

                      <div className="">
                        <div className="col-12 text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light mt-5 w-100 font-size-16"
                            type="submit"
                            onClick={() => {
                              handleValidSubmit()
                            }}
                          >
                            다음으로                        
                          </button>
                        </div>
                      </div>
                      
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

RegisterStep1.propTypes = {
  registerUser: PropTypes.func,
  registerUserFailed: PropTypes.func,
  registrationError: PropTypes.any,
  user: PropTypes.any,
}

const mapStatetoProps = state => {
  const { user, registrationError, loading } = state.Account
  return { user, registrationError, loading }
}

export default connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
})(RegisterStep1)
